import axios, { AxiosResponse } from 'axios'
import { AtendimentoList, AtendimentosQueryResponse } from '../../../atendimento/core/_models'
import { downloadArquivo, SituacaoAso } from '../../../../../../_metronic/helpers'
import { downloadAso, generateAso } from '../../../atendimento/core/_requests'

const API_URL = process.env.REACT_APP_API_URL
const ATENDIMENTO_ASO_URL = `${API_URL}/atendimentos/aso`

/**
 * Busca os atendimentos ASO
 * @param query string
 * @returns AtendimentosQueryResponse - AtendimentoList
 */
export const getAtendimentosAso = (query: string): Promise<AtendimentosQueryResponse> => {
  return axios
    .get(`${ATENDIMENTO_ASO_URL}?${query}`)
    .then((d: AxiosResponse<AtendimentosQueryResponse>) => d.data)
}

/**
 * Baixa o PDF do ASO de um atendimento. Se o ASO ainda não foi gerado (nem finalizado), gera
 * antes; senão só baixa o já existente. A situação vem da própria linha da listagem.
 * @param atendimento AtendimentoList
 */
export const baixarAso = async (atendimento: AtendimentoList): Promise<void> => {
  const jaGerado =
    atendimento.situacaoAso === SituacaoAso.Gerado ||
    atendimento.situacaoAso === SituacaoAso.Finalizado
  const arquivo = jaGerado ? await downloadAso(atendimento.id) : await generateAso(atendimento.id)
  await downloadArquivo(arquivo)
}

export type DownloadLoteResultado = {
  baixados: number
  erros: number
  /** Primeiro erro, para exibir quando o lote inteiro falhar. */
  primeiroErro?: unknown
}

/**
 * Baixa os ASOs de vários atendimentos em paralelo; um erro não cancela os demais.
 * @param atendimentos AtendimentoList[]
 * @returns DownloadLoteResultado
 */
export const baixarAsosLote = async (
  atendimentos: AtendimentoList[]
): Promise<DownloadLoteResultado> => {
  const resultados = await Promise.allSettled(atendimentos.map(baixarAso))
  const falhas = resultados.filter((r): r is PromiseRejectedResult => r.status === 'rejected')
  return {
    baixados: resultados.length - falhas.length,
    erros: falhas.length,
    primeiroErro: falhas[0]?.reason,
  }
}
